import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandLockup } from "@/components/LogoMark";
import { Reveal } from "@/components/Reveal";

export default function LegalPage({ page }) {
  return (
    <div data-testid={`legal-page-${page.slug}`} className="min-h-screen bg-sand">
      <header className="sticky top-0 z-50 border-b border-hairline bg-sand/85 backdrop-blur-xl">
        <div className="mx-auto flex h-[72px] max-w-4xl items-center justify-between px-5 sm:px-8">
          <Link to="/" data-testid="legal-logo-link">
            <BrandLockup />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 rounded-full border border-hairline bg-cream px-4 py-2 text-sm font-bold text-ink transition-colors hover:border-terracotta hover:text-terracotta"
          >
            <ArrowLeft size={15} /> Back to site
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-5 py-20 sm:px-8">
        <Reveal>
          <span className="text-xs font-bold uppercase tracking-[0.22em] text-terracotta">
            {page.updated}
          </span>
          <h1 className="mt-4 font-editorial text-4xl font-semibold tracking-tight sm:text-5xl">
            {page.title}
          </h1>
          <p className="mt-5 max-w-2xl font-editorial text-xl italic leading-relaxed text-clay">
            {page.intro}
          </p>
        </Reveal>

        <div className="mt-12 flex flex-col gap-8">
          {page.blocks.map((b, i) => (
            <Reveal key={b.h} delay={Math.min(i * 0.05, 0.3)}>
              <section
                data-testid={`legal-block-${page.slug}-${i}`}
                className="rounded-[24px] border border-hairline bg-cream p-7 sm:p-9"
              >
                <h2 className="text-lg font-extrabold tracking-tight">{b.h}</h2>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {b.bullets.map((item, j) => (
                    <li key={j} className="flex gap-3 text-sm leading-relaxed text-clay">
                      <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
                      {item}
                    </li>
                  ))}
                </ul>
              </section>
            </Reveal>
          ))}
        </div>

        <p className="mt-14 border-t border-hairline pt-8 text-xs leading-relaxed text-clay">
          STETH · Dating for healthcare professionals · © 2026 Wingwomen Inc.
          All rights reserved.
        </p>
      </main>
    </div>
  );
}
